if (!customElements.get('looping-carousel')) {
  customElements.define(
    'looping-carousel',
    class extends HTMLElement {
      connectedCallback() {
        this.list = this.querySelector('ul');
        this.originals = this.list ? Array.from(this.list.children) : [];
        if (this.originals.length < 2) return;

        this.scope = this.closest('.customer-testimonials') || this;
        this._onPrev = () => this.move(-1);
        this._onNext = () => this.move(1);
        this.scope.addEventListener('control:prev', this._onPrev);
        this.scope.addEventListener('control:next', this._onNext);
        this.addEventListener('scroll', () => {
          if (!this._animating && this.looping) {
            const max = this.scrollWidth - this.clientWidth;
            if (this.scrollLeft < this.step || this.scrollLeft > max - this.step) this.normalize();
          }
          clearTimeout(this._idle);
          this._idle = setTimeout(() => {
            this._animating = false;
            this.normalize();
          }, 120);
        });

        this._onResize = () => {
          clearTimeout(this._resize);
          this._resize = setTimeout(() => this.setup(), 150);
        };
        window.addEventListener('resize', this._onResize);

        this.setup();
        requestAnimationFrame(() => this.setup());
      }

      disconnectedCallback() {
        this.scope?.removeEventListener('control:prev', this._onPrev);
        this.scope?.removeEventListener('control:next', this._onNext);
        window.removeEventListener('resize', this._onResize);
        clearTimeout(this._idle);
        clearTimeout(this._resize);
      }

      setup() {
        this.list.querySelectorAll('[data-clone]').forEach((clone) => clone.remove());
        this.scrollLeft = 0;
        this.looping = this.originals.length >= 2;
        this.classList.toggle('is-scrollable', this.looping);
        if (!this.looping) return;

        this.list.append(this.cloneSet());
        this.setWidth = this.list.children[this.originals.length].offsetLeft - this.originals[0].offsetLeft;

        this.sets = Math.max(1, Math.ceil(this.clientWidth / this.setWidth));
        for (let i = 1; i < this.sets; i++) this.list.append(this.cloneSet());
        for (let i = 0; i < this.sets; i++) this.list.prepend(this.cloneSet());

        this.step = this.originals[1].offsetLeft - this.originals[0].offsetLeft;
        this.home = this.originals[0].offsetLeft - this.list.children[0].offsetLeft;
        this.scrollLeft = this.home;
      }

      cloneSet() {
        const fragment = document.createDocumentFragment();

        this.originals.forEach((item) => {
          const clone = item.cloneNode(true);
          clone.setAttribute('data-clone', '');
          clone.setAttribute('aria-hidden', 'true');
          clone.querySelectorAll('a, button, [tabindex]').forEach((el) => el.setAttribute('tabindex', '-1'));
          clone.querySelectorAll('video').forEach((video) => {
            video.removeAttribute('autoplay');
            video.preload = 'none';
          });
          fragment.appendChild(clone);
        });

        return fragment;
      }

      move(direction) {
        this.normalize();
        this._animating = true;
        const step = this.step || this.clientWidth;
        this.scrollTo({ left: this.scrollLeft + direction * step, behavior: 'smooth' });
      }

      normalize() {
        if (!this.looping) return;

        if (this.scrollLeft >= this.home + this.setWidth - 1) {
          this.scrollLeft -= this.setWidth * Math.floor((this.scrollLeft - this.home) / this.setWidth);
        } else if (this.scrollLeft <= this.home - 1) {
          this.scrollLeft += this.setWidth * Math.ceil((this.home - this.scrollLeft) / this.setWidth);
        }
      }
    }
  );
}
